export const workspaces = [
  {
    id: "ws1",
    name: "2026년 1학기 문화예술창업반",
    code: "ARTPEN-2601",
    instructor: "김민준 강사",
    created: "2026.03.01",
    studentCount: 18,
    teamCount: 4,
    status: "진행중",
  },
  {
    id: "ws2",
    name: "엔터테인먼트 비즈니스 워크샵 A반",
    code: "ARTPEN-WKSP",
    instructor: "이수진 강사",
    created: "2026.03.20",
    studentCount: 12,
    teamCount: 3,
    status: "준비중",
  },
];

export const teams = [
  {
    id: "team1",
    name: "스타라이트 엔터",
    workspaceId: "ws1",
    capital: 187500,
    reputation: 82,
    creditScore: 91,
    riskLevel: "낮음",
    activeProjects: 3,
    memberCount: 4,
    mode: "B",
    members: [
      { id: "s1", name: "김태형", role: "CEO", avatar: "김", online: true },
      { id: "s2", name: "박지은", role: "재무 담당", avatar: "박", online: true },
      { id: "s3", name: "이현우", role: "A&R 담당", avatar: "이", online: false },
      { id: "s4", name: "최민서", role: "마케팅 담당", avatar: "최", online: true },
    ],
  },
  {
    id: "team2",
    name: "루미너스 크리에이티브",
    workspaceId: "ws1",
    capital: 43200,
    reputation: 45,
    creditScore: 60,
    riskLevel: "높음",
    activeProjects: 2,
    memberCount: 4,
    mode: "A",
    members: [
      { id: "s5", name: "정다은", role: "CEO", avatar: "정", online: true },
      { id: "s6", name: "강민호", role: "법무 담당", avatar: "강", online: false },
      { id: "s7", name: "윤서연", role: "A&R 담당", avatar: "윤", online: true },
      { id: "s8", name: "한준혁", role: "마케팅 담당", avatar: "한", online: false },
    ],
  },
  {
    id: "team3",
    name: "노바뮤직",
    workspaceId: "ws1",
    capital: 124000,
    reputation: 68,
    creditScore: 78,
    riskLevel: "보통",
    activeProjects: 4,
    memberCount: 5,
    mode: "B",
    members: [
      { id: "s9", name: "송예진", role: "CEO", avatar: "송", online: true },
      { id: "s10", name: "임재원", role: "재무 담당", avatar: "임", online: true },
      { id: "s11", name: "오세린", role: "A&R 담당", avatar: "오", online: true },
      { id: "s12", name: "문지호", role: "법무 담당", avatar: "문", online: false },
      { id: "s13", name: "배소연", role: "마케팅 담당", avatar: "배", online: true },
    ],
  },
  {
    id: "team4",
    name: "드림캐처 엔터",
    workspaceId: "ws1",
    capital: 72000,
    reputation: 58,
    creditScore: 72,
    riskLevel: "보통",
    activeProjects: 2,
    memberCount: 3,
    mode: "A",
    members: [
      { id: "s14", name: "김다희", role: "CEO", avatar: "김", online: false },
      { id: "s15", name: "박성원", role: "재무 담당", avatar: "박", online: true },
      { id: "s16", name: "최유진", role: "마케팅 담당", avatar: "최", online: false },
    ],
  },
];

export const adminRoles = ["CEO / 대표이사", "재무 담당", "A&R 담당", "마케팅 담당", "법무 담당"];

export const manualEventTemplates = [
  { id: "me1", label: "엔젤 투자자 방문", type: "opportunity", icon: "ri-money-dollar-circle-line", repDelta: 10, capDelta: 30000, description: "엔젤 투자자가 자금을 수혈합니다. 자본금 +3천만원, 명성 +10" },
  { id: "me2", label: "국세청 세무조사", type: "crisis", icon: "ri-government-line", repDelta: -12, capDelta: -8000, description: "세무조사가 발동됩니다. 자본금 -800만원, 명성 -12" },
  { id: "me3", label: "언론 긍정 보도", type: "opportunity", icon: "ri-newspaper-line", repDelta: 20, capDelta: 5000, description: "언론 피처링이 터집니다. 명성 +20, 자본금 +500만원" },
  { id: "me4", label: "SNS 논란 발생", type: "crisis", icon: "ri-alarm-warning-line", repDelta: -18, capDelta: -3000, description: "SNS 악플 이슈. 명성 -18, 자본금 -300만원" },
  { id: "me5", label: "대형 페스티벌 섭외", type: "opportunity", icon: "ri-mic-line", repDelta: 25, capDelta: 20000, description: "대형 페스티벌 긴급 섭외. 명성 +25, 자본금 +2천만원" },
  { id: "me6", label: "핵심 멤버 이탈", type: "crisis", icon: "ri-user-unfollow-line", repDelta: -10, capDelta: -5000, description: "핵심 직원 이직. 명성 -10, 자본금 -500만원" },
];

export const inviteHistory = [
  { id: "inv1", email: "student01@karts.ac.kr", name: "김태형", status: "수락", joined: "2026.03.02", team: "스타라이트 엔터", role: "CEO" },
  { id: "inv2", email: "student02@karts.ac.kr", name: "박지은", status: "수락", joined: "2026.03.02", team: "스타라이트 엔터", role: "재무 담당" },
  { id: "inv3", email: "student05@karts.ac.kr", name: "정다은", status: "수락", joined: "2026.03.03", team: "루미너스 크리에이티브", role: "CEO" },
  { id: "inv4", email: "student10@karts.ac.kr", name: "임재원", status: "대기중", joined: "-", team: "미배정", role: "-" },
  { id: "inv5", email: "student11@karts.ac.kr", name: "오세린", status: "수락", joined: "2026.03.04", team: "노바뮤직", role: "A&R 담당" },
  { id: "inv6", email: "student17@karts.ac.kr", name: "권도현", status: "미수락", joined: "-", team: "미배정", role: "-" },
];
